import React, { useState } from "react";
import axios from 'axios';

const initialForm = {
  fullName: '',
  company: '',
  email: '',
  phone: '',
  message: '',
  services: [],
};

const servicesList = [
  'IT Consulting',
  'UI/UX Design',
  'Cloud Solution',
  'AI & Machine Learning',
  'Technical Support',
  'DevOps Services',
];

export default function Contact(props) {
    const [form, setForm]       = useState(initialForm);
  const [errors, setErrors]   = useState({});
  const [status, setStatus]   = useState('idle'); // idle | sending | success | error
  const [apiMessage, setApiMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleCheckbox = (service) => {
    const updated = form.services.includes(service)
      ? form.services.filter(s => s !== service)
      : [...form.services, service];
    setForm({ ...form, services: updated });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.fullName.trim()) newErrors.fullName = 'Full name is required';
    if (!form.email.trim())    newErrors.email    = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Enter a valid email';
    if (!form.message.trim())  newErrors.message  = 'Message is required';
    else if (form.message.trim().length < 10) newErrors.message = 'Message must be at least 10 characters';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setStatus('sending');
    try {
      const res = await axios.post('/api/contact', form)
      setStatus('success');
      setApiMessage(res.data.message);
      setForm(initialForm);
    } catch (err) {
      setStatus('error');
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
        setApiMessage('Please fix the errors above.');
      } else {
        setApiMessage('Something went wrong. Please try again.');
      }
    }
  };
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section style-2 mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="contact.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          Contact
                        </li>
                      </ul>
                      <h1>Start a Conversation With Our Expert Team</h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          Together, let’s build something truly remarkable
                          today.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="contact-page-top mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="contact-page-top-wrapper">
                      <div class="row gy-4">
                        <div class="col-lg-4 col-md-6">
                          <div class="single-contact">
                            <div class="content-top">
                              <h2>Email</h2>
                            
                            </div>
                            <ul class="contact-list">
                            
                            
                              <li>
                                <div class="icon">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M14.5312 2.21484H1.46875C1.07935 2.21528 0.70602 2.37017 0.430671 2.64551C0.155322 2.92086 0.000438372 3.29419 0 3.68359L0 12.3162C0.000438372 12.7056 0.155322 13.0789 0.430671 13.3542C0.70602 13.6296 1.07935 13.7845 1.46875 13.7849H14.5312C14.9207 13.7845 15.294 13.6296 15.5693 13.3542C15.8447 13.0789 15.9996 12.7056 16 12.3162V3.68359C15.9996 3.29419 15.8447 2.92086 15.5693 2.64551C15.294 2.37017 14.9207 2.21528 14.5312 2.21484ZM10.5616 7.99987L15.1822 3.37928C15.2269 3.47449 15.2501 3.5784 15.25 3.68359V12.3162C15.2501 12.4213 15.2269 12.5253 15.1822 12.6205L10.5616 7.99987ZM14.5312 2.96484H14.5358L8 9.50081L1.46416 2.96497H1.46875L14.5312 2.96484ZM0.817813 12.6205C0.773081 12.5253 0.749925 12.4213 0.75 12.3162V3.68359C0.749918 3.5784 0.773074 3.47449 0.817813 3.37928L5.43841 7.99987L0.817813 12.6205ZM1.46875 13.0349C1.46722 13.0349 1.46563 13.0349 1.46413 13.0349L5.96875 8.53019L7.73488 10.2963C7.8052 10.3666 7.90058 10.4061 8.00003 10.4061C8.09948 10.4061 8.19486 10.3666 8.26519 10.2963L10.0312 8.53022L14.5358 13.0348C14.5343 13.0348 14.5327 13.0348 14.5312 13.0348L1.46875 13.0349Z" />
                                  </svg>
                                </div>
                                <div class="content">
                                  <ul class="single-contact-list">
                                    <li>
                                      <a href="mailto:info@insightwide.com">
                                        info@insightwide.com
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                          <div class="single-contact">
                            <div class="content-top">
                              <h2>Phone</h2>
                            
                            </div>
                            <ul class="contact-list">
                            
                              <li>
                                <div class="icon">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <g>
                                        <path d="M12.6451 9.91174C12.3176 9.57067 11.9225 9.38832 11.5037 9.38832C11.0884 9.38832 10.6899 9.5673 10.3488 9.90836L9.28172 10.9721C9.19392 10.9248 9.10612 10.8809 9.0217 10.837C8.90013 10.7762 8.78532 10.7188 8.68739 10.658C7.68782 10.0232 6.77943 9.19584 5.90819 8.12535C5.48608 7.5918 5.20242 7.14267 4.99642 6.68679C5.27333 6.43352 5.52998 6.17012 5.77987 5.91685C5.87442 5.8223 5.96897 5.72437 6.06353 5.62982C6.77268 4.92067 6.77268 4.00215 6.06353 3.293L5.14163 2.3711C5.03695 2.26641 4.92889 2.15835 4.82758 2.05029C4.62496 1.84092 4.41222 1.6248 4.19272 1.42219C3.86516 1.098 3.47344 0.925781 3.06146 0.925781C2.64947 0.925781 2.251 1.098 1.91331 1.42219C1.90993 1.42556 1.90993 1.42556 1.90655 1.42894L0.758403 2.58722C0.326159 3.01947 0.0796448 3.54626 0.0256142 4.15748C-0.0554316 5.14354 0.234983 6.06206 0.457859 6.66315C1.00492 8.13886 1.82213 9.50651 3.04119 10.9721C4.52028 12.7382 6.29991 14.1329 8.33281 15.1156C9.1095 15.4836 10.1462 15.9193 11.3045 15.9936C11.3754 15.9969 11.4497 16.0003 11.5172 16.0003C12.2973 16.0003 12.9524 15.72 13.4657 15.1628C13.4691 15.1561 13.4758 15.1527 13.4792 15.146C13.6548 14.9332 13.8574 14.7407 14.0702 14.5347C14.2154 14.3963 14.364 14.2511 14.5092 14.0991C14.8435 13.7513 15.0191 13.3461 15.0191 12.9307C15.0191 12.512 14.8401 12.1101 14.499 11.7724L12.6451 9.91174ZM13.8541 13.4676C13.8507 13.4676 13.8507 13.471 13.8541 13.4676C13.7224 13.6095 13.5873 13.7378 13.4421 13.8796C13.2226 14.089 12.9997 14.3085 12.7903 14.555C12.4493 14.9197 12.0474 15.0919 11.5206 15.0919C11.47 15.0919 11.4159 15.0919 11.3653 15.0885C10.3623 15.0244 9.43031 14.6327 8.73129 14.2983C6.81996 13.3731 5.14163 12.0595 3.74697 10.3946C2.59544 9.00673 1.82551 7.7235 1.31559 6.34572C1.00154 5.50487 0.886726 4.84975 0.93738 4.23178C0.971149 3.83668 1.12311 3.50912 1.40339 3.22883L2.55492 2.07731C2.72039 1.92197 2.89599 1.83755 3.06821 1.83755C3.28095 1.83755 3.45318 1.96587 3.56124 2.07393C3.56462 2.07731 3.56799 2.08068 3.57137 2.08406C3.77736 2.27655 3.97322 2.47578 4.17921 2.68853C4.2839 2.79659 4.39196 2.90465 4.50002 3.01609L5.42192 3.93799C5.77987 4.29594 5.77987 4.62688 5.42192 4.98483C5.32398 5.08276 5.22943 5.18069 5.1315 5.27524C4.84784 5.56566 4.57769 5.83581 4.2839 6.09921C4.27714 6.10596 4.27039 6.10934 4.26701 6.11609C3.9766 6.40651 4.03063 6.69017 4.09141 6.88265C4.09479 6.89278 4.09817 6.90291 4.10154 6.91304C4.3413 7.49387 4.67899 8.04093 5.19229 8.69268L5.19566 8.69605C6.12769 9.8442 7.11037 10.7391 8.19436 11.4246C8.33281 11.5124 8.47464 11.5833 8.60972 11.6508C8.73129 11.7116 8.8461 11.769 8.94403 11.8298C8.95754 11.8366 8.97105 11.8467 8.98455 11.8535C9.09937 11.9109 9.20743 11.9379 9.31887 11.9379C9.59915 11.9379 9.77475 11.7623 9.83216 11.7049L10.9871 10.55C11.1019 10.4352 11.2842 10.2967 11.497 10.2967C11.7063 10.2967 11.8786 10.4284 11.9832 10.5432C11.9866 10.5466 11.9866 10.5466 11.99 10.55L13.8507 12.4107C14.1985 12.7551 14.1985 13.1097 13.8541 13.4676Z" />
                                        <path d="M8.64673 3.8067C9.53148 3.95529 10.3352 4.37403 10.9768 5.01564C11.6184 5.65725 12.0338 6.46096 12.1857 7.34571C12.2229 7.56858 12.4154 7.72392 12.6349 7.72392C12.6619 7.72392 12.6855 7.72054 12.7125 7.71717C12.9624 7.67664 13.1279 7.44026 13.0874 7.19037C12.905 6.11989 12.3985 5.14396 11.6252 4.37065C10.8519 3.59734 9.87593 3.0908 8.80545 2.90845C8.55556 2.86792 8.32255 3.03339 8.27865 3.27991C8.23475 3.52642 8.39684 3.76618 8.64673 3.8067Z" />
                                        <path d="M15.9819 7.05794C15.6813 5.29519 14.8506 3.69116 13.5741 2.41469C12.2977 1.13821 10.6936 0.307495 8.93089 0.00695018C8.68437 -0.0369496 8.45137 0.131896 8.40747 0.37841C8.36694 0.628301 8.53241 0.861308 8.7823 0.905208C10.3559 1.17198 11.7911 1.91828 12.9325 3.0563C14.0739 4.19769 14.8168 5.63288 15.0836 7.20652C15.1208 7.4294 15.3132 7.58473 15.5327 7.58473C15.5598 7.58473 15.5834 7.58136 15.6104 7.57798C15.8569 7.54083 16.0258 7.30445 15.9819 7.05794Z" />
                                      </g>
                                    </g>
                                  </svg>
                                </div>
                                <div class="content">
                                  <ul class="single-contact-list">
                                    <li>
                                      {" "}
                                      <a href="tel:2-965-871-8617">
                                      1300 378 911
                                      </a>
                                    </li>
                                  
                                  </ul>
                                </div>
                              </li>
                           
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-from-wrap mb-120">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-xl-7 col-md-10">
                    <div class="contact-form-wrap inner-contact-from">
                       <form onSubmit={handleSubmit} noValidate>
      <div className="row g-4 mb-40">

        <div className="col-md-6">
          <div className="form-inner">
            <label>Full name *</label>
            <input type="text" name="fullName" value={form.fullName} onChange={handleChange} />
            {errors.fullName && <span style={{color:'red', fontSize:'13px'}}>{errors.fullName}</span>}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-inner">
            <label>Company</label>
            <input type="text" name="company" value={form.company} onChange={handleChange} />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-inner">
            <label>Company Email *</label>
            <input type="email" name="email" value={form.email} onChange={handleChange} />
            {errors.email && <span style={{color:'red', fontSize:'13px'}}>{errors.email}</span>}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-inner">
            <label>Phone</label>
            <input type="text" name="phone" value={form.phone} onChange={handleChange} />
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-inner2">
            <label>How can We Assist You?</label>
            <ul>
              {servicesList.map((service) => (
                <li key={service}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={service}
                      checked={form.services.includes(service)}
                      onChange={() => handleCheckbox(service)}
                    />
                    <label className="form-check-label" htmlFor={service}>{service}</label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-inner">
            <label>Message *</label>
            <textarea name="message" value={form.message} onChange={handleChange} placeholder="Write your message" />
            {errors.message && <span style={{color:'red', fontSize:'13px'}}>{errors.message}</span>}
          </div>
        </div>

      </div>

      <button type="submit" className="primary-btn1" disabled={status === 'sending'}>
        <span>
          {status === 'sending' ? 'Sending...' : 'Submit'}
          {/* tumhara SVG arrow yahan */}
        </span>
      </button>

      {/* Status message — page reload nahi hoga */}
      {(status === 'success' || status === 'error') && (
        <div style={{
          marginTop: '16px',
          padding: '12px 20px',
          borderRadius: '8px',
          backgroundColor: status === 'success' ? '#d4edda' : '#f8d7da',
          color: status === 'success' ? '#155724' : '#721c24',
          fontSize: '15px'
        }}>
          {apiMessage}
        </div>
      )}
    </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
